export const geoserverServiceMessages = {
  CREATE_WMS_LAYER: {
    SUCCESS: 'Layer Created Successfully',
    ERROR: 'Error Creating Layer',
  },
  FALLBACK_ERROR: 'Something went wrong',
};
